
import moment from 'moment';
import { NewPeriodSelectorInterval } from 'src/app/core/enums/newPeriodSelectorInterval';
import { NewCalendarPeriodFilter } from 'src/app/core/models/period-selector/newCalendarPeriodFilter';
import { NewCalendarPeriodSelectorItem } from './base/new-calendar-period-selector-item';

export class MonthPeriodSelectorItem extends NewCalendarPeriodSelectorItem {
    interval = NewPeriodSelectorInterval.Month;
    hasNavigation = true;

    constructor(name: string) {
        super(name);
    }

    getPeriodFilter = () => {
        let endDate: Date;
        const currentDate = moment().startOf('day').toDate();
        endDate = currentDate;
        const firstDayOfTheMonth = moment(endDate).startOf('month').toDate();
        const startDate = moment(firstDayOfTheMonth).startOf('day').toDate();
        endDate = moment(endDate).endOf('day').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = startDate;
        periodFilter.endDate = endDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Month;

        return periodFilter;
    }

    getPreviousPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        let newStartDate;
        let newEndDate = moment(currentFilter.startDate)
            .add(-1, 'day')
            .toDate();
        newStartDate = moment(newEndDate).startOf('month').toDate();
        newEndDate = moment(newEndDate).endOf('month').toDate();

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Month;

        return periodFilter;
    }

    getNextPeriodFilter = (currentFilter: NewCalendarPeriodFilter) => {
        const newStartDate = moment(currentFilter.endDate).add(1, 'day').startOf('day').toDate();
        let newEndDate = moment(newStartDate).endOf('month').toDate();

        if (moment(newEndDate).endOf('day') > moment().endOf('day')) {
            newEndDate = moment().endOf('day').toDate();
        }

        const periodFilter = new NewCalendarPeriodFilter();
        periodFilter.startDate = newStartDate;
        periodFilter.endDate = newEndDate;
        periodFilter.periodInterval = NewPeriodSelectorInterval.Month;

        return periodFilter;
    }
}
